import React, {useEffect, useRef, useState} from 'react';
import './tellAboutYouSection.scss';
import {openPositions} from "../../../../components/utils/dataLists";
import Select, { components } from 'react-select';

interface TellAboutYouProps {
	selectedPosition: any;
	setSelectedPosition: (item: any) => void;
}

const TellAboutYouSection = (props: TellAboutYouProps) => {
	const [name, setName] = useState('');
	const [location, setLocation] = useState('');
	const [contactYou, setContactYou] = useState('');
	const [workExperience, setWorkExperience] = useState('');
	const [preferOnsite, setPreferOnsite] = useState('');
	const [aboutYourself, setAboutYourself] = useState('');
	const [salaryExpectations, setSalaryExpectations] = useState('');
	const aboutTextareaRef = useRef(null) as any;
	const [width, setWidth] = useState(window.innerWidth);

	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);

	const autoResizeTextarea = (textarea: any) => {
		textarea.style.height = 'auto';
		textarea.style.height = `${textarea.scrollHeight}px`;
	};

	const handleSelectChange = (selectedOption: any) => {
		if(openPositions.length === 0) return;
		const selectedItem = openPositions.find(item => item.id === selectedOption.value);
		props.setSelectedPosition(selectedItem);
	};

	const options = openPositions.map((item: any) => ({
		value: item.id,
		label: item.title,
		title: item.title,
		position: item.position,
	}));

	const CustomOption = (props: any) => {
		const { data, isSelected, innerRef, innerProps } = props;

		return (
			<div
				ref={innerRef}
				{...innerProps}
				className={`custom-option ${isSelected ? 'selected' : ''}`}
			>
				<div className="custom-option_text">
					<h3>{data.title}</h3>
					<span>{data.position}</span>
				</div>
				<div className={`custom-option_icon ${isSelected ? 'selected' : ''}`}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="25"
						viewBox="0 0 24 25"
						fill="none"
					>
						<path
							d="M9.71012 19.6212C9.61746 19.7144 9.5073 19.7883 9.38597 19.8388C9.26464 19.8893 9.13453 19.9152 9.00312 19.9152C8.87171 19.9152 8.7416 19.8893 8.62026 19.8388C8.49893 19.7883 8.38877 19.7144 8.29612 19.6212L2.65012 13.9742C2.36891 13.6929 2.21094 13.3115 2.21094 12.9137C2.21094 12.516 2.36891 12.1345 2.65012 11.8532L3.35712 11.1462C3.63841 10.865 4.01987 10.707 4.41762 10.707C4.81536 10.707 5.19683 10.865 5.47812 11.1462L9.00312 14.6712L18.5281 5.14621C18.8094 4.865 19.1909 4.70703 19.5886 4.70703C19.9864 4.70703 20.3678 4.865 20.6491 5.14621L21.3561 5.85321C21.6373 6.1345 21.7953 6.51596 21.7953 6.91371C21.7953 7.31146 21.6373 7.69292 21.3561 7.97421L9.71012 19.6212Z"
							fill="#7551FF"
						/>
					</svg>
				</div>
			</div>
		);
	};

	const DropdownIndicator = (props: any) => {
		const { selectProps } = props;
		const isOpen = selectProps.menuIsOpen;

		return (
			<components.DropdownIndicator {...props}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="25"
					height="25"
					viewBox="0 0 25 25"
					fill="none"
					style={{
						transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
						transition: 'all 0.2s ease',
					}}
				>
					<path
						d="M7.14062 9.82031L12.4978 15.1775L17.8549 9.82031"
						stroke={isOpen ? "#7551FF" : "#9896AE"}
						strokeWidth="2"
						style={{
							transition: 'all 0.2s ease',
						}}
					/>
				</svg>
			</components.DropdownIndicator>
		);
	};

	const CustomSingleValue = (props: any) => {
		const { data } = props;

		return (
			<div className="custom-single-value">
				<strong>{data.title}</strong>
				<small style={{ color: '#666', marginLeft: '10px' }}>{data.position}</small>
			</div>
		);
	};

	return (
		<div className="tellAboutYou" id={"introduce"}>
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<form className="tellAboutYou__form">
				<div className="tellAboutYou__form_content">
					<h2>Tell us about you</h2>
					<div className="tellAboutYou__form_content_inputs">
						<textarea
							value={name}
							onChange={(e) => {
								setName(e.target.value);
								autoResizeTextarea(e.target);
							}}
							rows={1}
							placeholder={'Your name'}
						/>
						<textarea
							value={location}
							onChange={(e) => {
								setLocation(e.target.value);
								autoResizeTextarea(e.target);
							}}
							rows={1}
							placeholder={'Your location'}
						/>
						<textarea
							value={contactYou}
							onChange={(e) => {
								setContactYou(e.target.value);
								autoResizeTextarea(e.target);
							}}
							rows={1}
							placeholder={'How can we contact you?'}
						/>
						<Select
							className="tellAboutYou__select_container"
							classNamePrefix="react__select"
							options={options}
							value={options.find(option => option.value === props.selectedPosition?.id)}
							onChange={handleSelectChange}
							placeholder={'What position do you want to apply for?'}
							styles={{
								indicatorSeparator: (): any => {},
							}}
							components={{
								Option: CustomOption,
								// SingleValue: CustomSingleValue,
								DropdownIndicator: DropdownIndicator,
							}}
						/>
						<textarea
							value={workExperience}
							onChange={(e) => {
								setWorkExperience(e.target.value);
								autoResizeTextarea(e.target);
							}}
							rows={width > 767 ? 1 : 2}
							placeholder={'Previous work experience (CV link)'}
						/>
						<textarea
							value={preferOnsite}
							onChange={(e) => {
								setPreferOnsite(e.target.value);
								autoResizeTextarea(e.target);
							}}
							rows={width > 767 ? 1 : 2}
							placeholder={'Do you prefer onsite or remote format?'}
						/>
						<textarea
							ref={aboutTextareaRef}
							value={aboutYourself}
							onChange={(e) => {
								setAboutYourself(e.target.value);
								autoResizeTextarea(e.target);
							}}
							rows={4}
							placeholder={'Tell us about yourself'}
						/>
						<textarea
							value={salaryExpectations}
							onChange={(e) => {
								setSalaryExpectations(e.target.value);
								autoResizeTextarea(e.target);
							}}
							rows={1}
							placeholder={'Your salary expectations'}
						/>
					</div>
					<div className="tellAboutYou__form_button">
						<button className="borderButton">
							<span>Send application</span>
						</button>
					</div>
				</div>
			</form>
			<div className="tellAboutYou__background"></div>
		</div>
	);
};

export default TellAboutYouSection;